import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["animation", "className", "timeout", "children", "show", "style", "asGroup"];
import React, { isValidElement } from 'react';
import cn from 'classnames';
import { CSSTransition as RTGCCTransition } from 'react-transition-group';

var CSSTransition = function CSSTransition(_ref) {
  var animation = _ref.animation,
      className = _ref.className,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 255 : _ref$timeout,
      children = _ref.children,
      show = _ref.show,
      style = _ref.style,
      _ref$asGroup = _ref.asGroup,
      asGroup = _ref$asGroup === void 0 ? false : _ref$asGroup,
      props = _objectWithoutProperties(_ref, _excluded);

  var transitionProps = !asGroup ? _extends({}, props, {
    "in": show
  }) : props;
  return animation ? /*#__PURE__*/React.createElement(RTGCCTransition, _extends({}, transitionProps, {
    classNames: animation,
    timeout: timeout,
    style: style,
    className: cn('css-transition', className, /*#__PURE__*/isValidElement(children) ? children.props.className : undefined)
  }), children) : children;
};

export default CSSTransition;